export const textTranslations = (section, language, props) => {
    if(language === "english") {
        if(section === "title") {
            return "Oops! Something went wrong.";
        }
        if(section === "customer-not-verified") {
            return (<div>
                    <h2>Please create your own account!</h2>
                </div>)
        }
        if(section === "unknown-error") {
            return "It seems like there was an error processing your request."
        }
        if(section === "support-line") {
            return "If you would like help, please email me!"
        }
        if(section === "contact-support") {
            return "Email me";
        }
    } else if(language === "sinhala") {
        if(section === "title") {
            return "අපොයි! යමක් වැරදී ඇත.";
        }
        if(section === "customer-not-verified") {
            return (<div>
                <h2>කරුණාකර ඔබේම ගිණුමක් සාදන්න!</h2>
            </div>)
        }
        if(section === "unknown-error") {
            return "ඔබගේ ඉල්ලීම සැකසීමේදී දෝෂයක් ඇති වූ බව පෙනේ."
        }
        if(section === "support-line") {
            return "ඔබට උදව් අවශ්‍ය නම්, කරුණාකර මට විද්‍යුත් තැපැල් කරන්න!"
        }
        if(section === "contact-support") {
            return "ඊමේල් කරන්න";
        }
    }
}